export const CHANGE_COLLECTION_VERSION = 'CHANGE_COLLECTION_VERSION';

export const START_DATA_LOADING = 'START_DATA_LOADING';
export const FINISH_DATA_LOADING = 'FINISH_DATA_LOADING';
